import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import React, { useContext } from 'react';
import { slide as Menu } from 'react-burger-menu';
import { useStaticQuery } from 'gatsby';
import { GlobalContext, LanguageContext } from '@interness/web-core/src/providers';
import MenuStructure from '@interness/web-core/src/components/structure/MenuStructure/MenuStructure';
import * as S from './style';
import { findT } from '@interness/web-core/src/components/_helpers';
import NewMenuStructure from '@interness/web-core/src/components/structure/MenuStructure/NewMenuStructure';
import { jsx as ___EmotionJSX } from "@emotion/react";
const Sidebar = () => {
  const menuStyles = {
    bmMenuWrap: {
      position: 'fixed',
      height: '100%',
      width: '100%',
      maxWidth: '350px'
    }
  };
  const menuOptions = {
    right: true,
    pageWrapId: 'page-wrap',
    outerContainerId: 'outer-container',
    customBurgerIcon: false,
    customCrossIcon: false,
    noOverlay: false,
    styles: _objectSpread({}, menuStyles),
    disableOverlayClick: () => toggleMenu(),
    disableCloseOnEsc: true
  };
  const {
    primaryMenuOpen,
    togglePrimaryMenu
  } = useContext(GlobalContext);
  const toggleMenu = () => togglePrimaryMenu(!primaryMenuOpen);
  const {
    language
  } = useContext(LanguageContext);
  const data = useStaticQuery(query);
  const menu = data.directusMenus ? findT(data.directusMenus.translations, language).config : null;
  const menuNew = data.directusMenusNew ? data.directusMenusNew.config : null;
  return ___EmotionJSX(Menu, _extends({
    isOpen: primaryMenuOpen
  }, menuOptions), ___EmotionJSX(S.Sidebar, null, menuNew ? ___EmotionJSX(NewMenuStructure, {
    menu: menuNew
  }) : ___EmotionJSX(MenuStructure, {
    menu: menu
  })));
};
const query = "169925597";
export default Sidebar;